export const UserStatusCssClasses = [
  "info",
  "success",
  "info",
  "info",
  "danger",
  ""
];
export const UserStatusTitles = [
  "New",
  "Active",
  "InActive",
  "ReActive",
  "Blocked",
  ""
];
export const UserRoleCssClasses = ["danger", "success", "info", ""];
export const UserRoleTitles = ["Admin", "Supervisor", "User", ""];
export const defaultSorted = [{ dataField: "name", order: "asc" }];
export const sizePerPageList = [
  { text: "100", value: 100 },
  { text: "50", value: 50 },
  { text: "25", value: 25 }
];
export const userStatusList = [
  { value: 0, label: "Шинэ" },
  { value: 1, label: "Идэвхтэй" },
  { value: 2, label: "Идэвхгүй" },
  { value: 3, label: "Дахин идэвхжсэн" },
  { value: 5, label: "Хаагдсан" }
];
export const initialFilter = {
  filter: {
    name: "",
    email: "",
    mobileNo: ""
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 100
};
